var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 834.81,
    height: 635.008,
    viewBox: "0 0 834.81 635.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:rgba(0,0,0,.14)}.cls-4{fill:#fff}.cls-6,.cls-64,.cls-8{fill:#404040}.cls-6{font-family:OpenSans-Bold,Open\n            Sans;font-weight:700;font-size:2px}.cls-7{fill:#efecec}.cls-8{font-size:12px;font-family:OpenSans,Open\n            Sans}.cls-9{font-family:GeezaPro,Geeza Pro}.cls-11{font-family:GeezaPro-Bold,Geeza\n            Pro}.cls-12{fill:#805901}.cls-13{fill:#f8cdba}.cls-14{fill:#a78028}.cls-16,.cls-20,.cls-27,.cls-35,.cls-36,.cls-37,.cls-38,.cls-43,.cls-56,.cls-60{fill:none;stroke-linecap:round}.cls-16{stroke:#2b279b;stroke-width:.55px}.cls-16,.cls-20,.cls-35,.cls-36,.cls-37,.cls-38,.cls-43{stroke-miterlimit:10}.cls-17{fill:#1f161e}.cls-20{stroke:#ac8b56}.cls-20,.cls-37{stroke-width:4px}.cls-23{fill:#c61414}.cls-25{fill:#73e5e2}.cls-27{stroke:#2caaa7}.cls-27,.cls-56,.cls-60{stroke-linejoin:round}.cls-28{fill:#fbdc8e}.cls-37,.cls-38{stroke:#000}.cls-38{stroke-width:2px}.cls-30{fill:#ab8de5}.cls-34{fill:#be9381}.cls-35{stroke:#e2a203}.cls-36{stroke:#c332bd;stroke-dasharray:2}.cls-40{fill:#0f2721}.cls-42{fill:#484347}.cls-43{stroke:#2b9033}.cls-45{fill:#817c7c}.cls-55{fill:#899594}.cls-56{stroke:#1f161e}.cls-60{stroke:#fff;stroke-width:.4px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3040",
    transform: "translate(-68.006 -91.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    fill: "#f0f0f0",
    d: "M357.833-67.14c116.62 0 431.808 121.261 288.726 331.092s-427.168 286.3-506.365 288.7-278.044 84.964-291.562-161S241.213-67.14 357.833-67.14z",
    transform: "translate(219.705 158.57)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shadows",
    transform: "translate(81.884 549.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    d: "M0 2.47c0 4.885 121.187 31.188 120.673 23.053S0-7.934 0 2.47z",
    className: "cls-2",
    transform: "matrix(0.974, -0.225, 0.225, 0.974, 583.407, 55.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    d: "M0 2.47c0 4.885 121.187 31.188 120.673 23.053S0-7.934 0 2.47z",
    className: "cls-2",
    transform: "matrix(0.974, -0.225, 0.225, 0.974, 486.375, 50.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    d: "M0 3.768c0 7.453 181.376 47.582 180.607 35.171S0-12.1 0 3.768z",
    className: "cls-2",
    transform: "matrix(0.974, -0.225, 0.225, 0.974, 326.219, 50.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    d: "M0 4.177c0 8.262 201.062 52.746 200.209 38.988S0-13.418 0 4.177z",
    className: "cls-2",
    transform: "matrix(0.974, -0.225, 0.225, 0.974, 114.063, 45.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    d: "M0 3.063c0 6.06 127.8 38.684 127.257 28.594S0-9.841 0 3.063z",
    className: "cls-2",
    transform: "matrix(0.974, -0.225, 0.225, 0.974, 32.844, 38.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    d: "M0 2.114C0 6.3 91.685 28.815 91.3 21.851S0-6.792 0 2.114z",
    className: "cls-2",
    transform: "matrix(0.974, -0.225, 0.225, 0.974, 0, 59.782)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    fill: "#d9d9d9",
    d: "M216.967 110.975a14.482 14.482 0 0 0-3.479.45l-23.379-38.912a13.116 13.116 0 0 0 1.418-18.807 15.8 15.8 0 0 0-20.162-2.687c-6.444 4.13-8.352 12.163-4.373 18.413L149.9 85.253a15.725 15.725 0 0 0-19.053 4.206 13.1 13.1 0 0 0 1.771 18.054l-24.467 45.317a15.559 15.559 0 0 0-3.142-.312 15.872 15.872 0 0 0-7.481 1.973l-17.096-15.82c4.1-6.312 2.152-14.493-4.444-18.616a15.77 15.77 0 0 0-20.32 3.134 13.144 13.144 0 0 0 2.32 18.944l6.471 3.15a15.558 15.558 0 0 0 3.142.312 15.872 15.872 0 0 0 7.481-1.973l17.095 15.821c-4.03 6.313-2.044 14.439 4.53 18.533a15.774 15.774 0 0 0 20.256-3.1 13.137 13.137 0 0 0-2.155-18.9l24.464-45.317a15.555 15.555 0 0 0 3.142.312A15.2 15.2 0 0 0 155.278 104a12.959 12.959 0 0 0-.032-13.8l17.095-15.821a15.872 15.872 0 0 0 7.481 1.973 16.452 16.452 0 0 0 3.741-.485l23.379 38.947a13.115 13.115 0 0 0-3.234 16.029 15.255 15.255 0 0 0 15.492 7.766c6.438-.8 11.584-5.349 12.739-11.265a13.553 13.553 0 0 0-7.677-14.676l22.893-87.449-7.481-1.593z",
    transform: "translate(342.177 239.798)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    transform: "translate(162.177 135.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    d: "M162.865 232.841h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0h6.5l-3.251 4.272zm-6.5 0H6.8l-3.251 4.272zm0 0V4.272H0L3.251 0 6.5 4.272 9.754 0 13 4.272 16.256 0l3.251 4.272L22.759 0l3.251 4.272L29.261 0l3.251 4.272L35.764 0l3.251 4.272L42.266 0l3.251 4.272L48.769 0l3.251 4.272L55.271 0l3.251 4.272L61.774 0l3.251 4.272L68.276 0l3.251 4.272L74.779 0l3.251 4.272L81.281 0l3.251 4.272L87.784 0l3.251 4.272L94.287 0l3.251 4.272L100.789 0l3.251 4.272L107.291 0l3.251 4.272L113.794 0l3.251 4.272L120.3 0l3.251 4.272L126.8 0l3.251 4.272L133.3 0l3.251 4.272L139.8 0l3.251 4.272L146.306 0l3.251 4.272L152.809 0l3.251 4.272L159.312 0l3.251 4.272L165.814 0l3.251 4.272v228.569z",
    className: "cls-4",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Invoice",
    fill: "#404040",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: "8px",
    fontWeight: 700,
    transform: "translate(13.55 24.807)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Invoice")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    transform: "translate(13.55 182.916)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1200",
    className: "cls-6",
    transform: "translate(36.132 2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$1200")), /*#__PURE__*/React.createElement("text", {
    id: "Total:",
    className: "cls-6",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total:"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    width: 53.068,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(13.549 39.519)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    width: 53.068,
    height: 6.775,
    className: "cls-7",
    rx: 3.387,
    transform: "translate(13.549 76.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    width: 63.23,
    height: 9.033,
    className: "cls-7",
    rx: 4.516,
    transform: "translate(13.549 90.329)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    width: 53.068,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(13.549 103.878)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    transform: "translate(13.55 127.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    width: 62.101,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    width: 27.099,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(76.78 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    width: 25.97,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(116.299 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    transform: "translate(13.55 141.139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247-2",
    width: 62.101,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248-2",
    width: 27.099,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(76.78 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249-2",
    width: 25.97,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(116.299 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    transform: "translate(13.55 154.688)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247-3",
    width: 62.101,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248-3",
    width: 27.099,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(76.78 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249-3",
    width: 25.97,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(116.299 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    width: 142.268,
    className: "cls-7",
    transform: "translate(13.549 119.686)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    width: 142.268,
    className: "cls-7",
    transform: "translate(13.549 171.625)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    width: 51.939,
    height: 9.033,
    className: "cls-7",
    rx: 4.516,
    transform: "translate(103.878 90.329)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    width: 28.228,
    height: 7.904,
    className: "cls-7",
    rx: 3.952,
    transform: "translate(127.59 51.939)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    width: 22.582,
    height: 12.42,
    className: "cls-7",
    rx: 5,
    transform: "translate(133.235 18.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    d: "M0 8.311l3.953-4.892 2.5 2.911L11.6 0l5.352 8.311zm4.229-6.132a1.366 1.366 0 1 1 1.366 1.365 1.366 1.366 0 0 1-1.366-1.365z",
    className: "cls-4",
    transform: "translate(136.702 19.932)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    width: 142.268,
    height: 2.258,
    className: "cls-7",
    rx: 1.129,
    transform: "translate(13.549 205.498)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "No.",
    className: "cls-8",
    transform: "translate(117.429 35.001)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.276,
    y: 13
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 13,
    className: "cls-9"
  }, "No."), /*#__PURE__*/React.createElement("tspan", {
    y: 13
  })), /*#__PURE__*/React.createElement("text", {
    id: "Date",
    className: "cls-8",
    transform: "translate(111.783 73.391)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.255,
    y: 13
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 13,
    className: "cls-9"
  }, "Date")), /*#__PURE__*/React.createElement("text", {
    id: "Date",
    className: "cls-8",
    transform: "translate(98.234 100.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32.676,
    y: 13
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 13,
    className: "cls-9"
  }, "Date")), /*#__PURE__*/React.createElement("text", {
    id: ":",
    fill: "#404040",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: "3px",
    fontWeight: 700,
    transform: "translate(103.879 184.786)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ":"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    className: "cls-11"
  }, "Total"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    className: "cls-11"
  }, "Amount"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(680.09 304.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    d: "M74.552 354.48c0 1.339.62 9.2-.474 10.548-1.992 2.449-18.654 1.788-19.454 1.029s-1.314-2.376-.629-2.866 7.266-2 8.164-2.653 2.033-3.976 1.518-5.715",
    className: "cls-12",
    transform: "translate(11.348 -66.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    d: "M141.573 354.48c0 1.339.629 9.2-.474 10.548-1.992 2.449-18.646 1.788-19.446 1.029s-1.323-2.376-.629-2.866 7.258-2 8.164-2.653 2.033-3.976 1.51-5.715",
    className: "cls-12",
    transform: "translate(-110.395 -66.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    d: "M150.924 179.76a10.164 10.164 0 0 1 1.045 4.588c0 4.27-2.384 7.731-5.315 7.731s-5.315-3.461-5.315-7.731a10.164 10.164 0 0 1 1.045-4.588z",
    className: "cls-13",
    transform: "translate(-137.462 -34.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    d: "M112.666 322.425c-1.633-1.9-6.286-142.769-6.286-142.769l17.324-.376s13.879 38.46 13.879 40.109-7.111 34.288-9.8 42.893c-.171 4.678.694 59.269-.694 60.568s-12.798 1.518-14.423-.425z",
    className: "cls-14",
    transform: "translate(-94.534 -34.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    d: "M51.5 178.306c0 8.074 26.124 66.666 31.121 73.948 3.037 9.7 15.168 65.5 16.932 66.821s13.013 2.645 14.336 0-16.676-130.948-19.942-147.186S51.5 162.24 51.5 178.306z",
    className: "cls-14",
    transform: "translate(-26.097 -31.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    fill: "#556cb7",
    d: "M124.8 67.31c-5.3-6.123-51.681-9.968-57.142-5.71-11.021 8.572-3.266 95.517-2.449 98.782.816 1.633 6.531-1.633 6.531-1.633.816.816 41.636 2.449 57.147-5.715 0-4.082-2.449-21.226-2.449-21.226 3.266 0 12.246-2.449 13.879-4.9S131.05 74.5 124.8 67.31z",
    transform: "translate(-61.037 -12.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    d: "M118.884 149c-3.551.629-30.941 2.661-40.444 1.9",
    className: "cls-16",
    transform: "translate(-53.026 -28.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    d: "M89.887 134.175c25.92-5.592 38.256-2.58 30-27.235",
    className: "cls-16",
    transform: "translate(-65.918 -21.157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    d: "M145.47 102.41c.139 2.327 1.78 64.241 1.78 64.241",
    className: "cls-16",
    transform: "translate(-136.114 -20.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    d: "M115.94 60.361c0 2.131 11.707 2.253 11.7 0V46.14h-11.7z",
    className: "cls-13",
    transform: "translate(-92.395 -9.993)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    cx: 15.193,
    cy: 15.193,
    r: 15.193,
    className: "cls-13",
    transform: "translate(8.694 11.378)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    cx: 3.347,
    cy: 3.347,
    r: 3.347,
    className: "cls-13",
    transform: "translate(32.819 21.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    d: "M137.336 29.5c0 4.457 7.543 2.025 5.233 0a16.706 16.706 0 0 0 3.4-9.56c0-5.462-16.713-18.072-21.611-18.072-4.531 0-6.35.463-6.35 2.063 0 3.519-2.719 4.449-6.115 4.449-2.163 0-4.9.612-4.9 3.576 0 5.445 5.1 8.6 6.809 9.478a15.2 15.2 0 0 1 2.449-3.478c-.318 1.029.939 2.9 3.347 3.315 1.394.224 17.738-1.981 17.738 8.229z",
    className: "cls-17",
    transform: "translate(-103.432 -1.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    fill: "#bcbcbc",
    d: "M143.936 152.079h9.127s2.784-25.928 2.784-27.961-14.507-1.78-14.507 0 2.596 27.961 2.596 27.961z",
    transform: "translate(-141.34 -24.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    d: "M137.279 135.22c-1.3 0-8.719 1.755-8.719 5.576 0 4.694 5.821 6.294 6.964 6.294 6.147 0 7.878-1.053 17.691-1.053 0-1.151-.212-6.425-1.576-6.939-1.665.024-6.392-3.878-14.36-3.878z",
    className: "cls-13",
    transform: "translate(-128.274 -26.349)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2688",
    transform: "translate(246.28 376.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    transform: "translate(0 147.926)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    cx: 33.34,
    cy: 7.369,
    fill: "#ac8b56",
    rx: 33.34,
    ry: 7.369,
    transform: "translate(4.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_87",
    d: "M0 0L18.727 58.612",
    className: "cls-20",
    transform: "translate(50.458 6.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_97",
    d: "M0 0L18.727 58.612",
    className: "cls-20",
    transform: "translate(40.661 14.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_88",
    d: "M18.727 0L0 58.612",
    className: "cls-20",
    transform: "translate(0 7.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    fill: "none",
    stroke: "#ac8b56",
    strokeLinecap: "round",
    strokeWidth: "4px",
    d: "M5.9 0L0 58.43",
    transform: "translate(22.02 7.37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    transform: "translate(14.436 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2690",
    transform: "translate(71.088 117.078) rotate(-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    fill: "#f4c2ac",
    d: "M16.559 0c4.709 11.1 25.734 88.617 25.548 90.429s-12.207-8.262-13.229-9.3c-1.726-1.733-4.944-22.2-12.318-28.356-.11-.257-11.871-35.69-12.487-36.347-1.036-1.1-2.589-.678-3.514-.374C-1.848 9.538 3.538 1.8 16.559 0z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    d: "M0 0c0 1.576.431 14.351 2.265 15.272l1.271-.247-.395-8.868a28.81 28.81 0 0 0 20.687 6.783c3.451-.6-4.4-4-6.486-6.12A25.641 25.641 0 0 1 13.6 1.475C20.8 16.275 1.418.008 1.418.008",
    className: "cls-23",
    transform: "translate(27.796 78.427) rotate(11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2689",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 59.333, 107.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815-2",
    d: "M26.986 0c7.674 11.1 41.939 88.617 41.635 90.429s-9.283-4.7-10.948-5.734c-2.812-1.733-10.978-26.28-23-32.437C34.5 52 7.641 17.085 6.637 16.428c-1.689-1.1-4.22-.678-5.727-.374C-3.012 9.538 5.766 1.8 26.986 0z",
    className: "cls-13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826-2",
    d: "M0 0c0 1.576.431 14.351 2.265 15.272l1.271-.247-.395-8.868a28.811 28.811 0 0 0 20.687 6.783c3.451-.6-4.4-4-6.486-6.12A25.643 25.643 0 0 1 13.6 1.475C20.8 16.275 1.418.008 1.418.008",
    className: "cls-23",
    transform: "translate(52.678 78.427) rotate(11)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    fill: "#5560b7",
    d: "M0 196.647c0 31.559 10.04 38.187 20.028 38.187 25.3 0 29.953-1.034 52.623-4.787 2.084-22.53 19.68-40.723 13.888-41.3-2.449-.245-26.332 0-26.332 0",
    transform: "translate(0 -78.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    d: "M51.531 57.56c11.443 0 14.733 10.835 15.68 14.926 3.027 13.062-5.4 62.7-6.376 64.065-8.281 11.578-55.62 12.606-60.235 7.592S20.264 57.56 51.531 57.56z",
    className: "cls-25",
    transform: "translate(-0.014 -23.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    d: "M85.214 54.322c-.31.994 7.767 3.507 8.077 2.519l3.133-10.052-8.072-2.519z",
    className: "cls-13",
    transform: "translate(-35.409 -18.419)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    cx: 11.858,
    cy: 11.858,
    r: 11.858,
    className: "cls-13",
    transform: "translate(50.46 8.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    fill: "#4e352a",
    d: "M20.153.009C-.457-.231 3.607 4.155.584 10.34s6.63 14.3 7.478 14.409c5.464.69 14.447-8.8 17.2-9.848 4.675-1.794 10.181 2.864 17.106 2.571C43.9 14.334 40.764.25 20.153.009z",
    transform: "matrix(0.719, -0.695, 0.695, 0.719, 28.784, 29.664)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hand",
    transform: "translate(33.818 55.677)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_172",
    cx: 6.353,
    cy: 6.353,
    r: 6.353,
    className: "cls-13",
    transform: "translate(63.399 39.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    d: "M.892.8C.307 4.459-1.586 39 2.949 42.365c9.713 7.194 54.568-1.607 61.365-4.126.736-2.408 0-10.058 0-10.058-2.618-.105-35.65-.421-37.62-2.922S24.491 2.308 24.807 0",
    className: "cls-25",
    transform: "translate(8.612 0) rotate(11)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    d: "M110.573 129.039c-1.993-2.519-2.2-22.95-1.888-25.259",
    className: "cls-27",
    transform: "translate(-45.117 -43.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    d: "M89.938 166.663c-9.152.508-17.153 0-20.636-2.595-1.987-1.467-2.741-8.907-2.922-17.118",
    className: "cls-27",
    transform: "translate(-27.586 -61.09)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "lamp",
    transform: "translate(367.011 231.835)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    width: 6.688,
    height: 18.231,
    rx: 3.344,
    transform: "translate(16.889 69.537)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    cx: 6.709,
    cy: 6.709,
    r: 6.709,
    className: "cls-28",
    transform: "translate(13.524 93.753)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    cx: 8.42,
    cy: 8.42,
    r: 8.42,
    className: "cls-4",
    transform: "translate(11.699 92.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_93",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    d: "M0 73.388L0 0",
    transform: "translate(20.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    d: "M166.723 152.88a20.228 20.228 0 0 1 20.233 20.228H146.49a20.228 20.228 0 0 1 20.233-20.228z",
    className: "cls-30",
    transform: "translate(-146.49 -72.645)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "person2",
    transform: "translate(583.261 319.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    fill: "#c468c1",
    d: "M767.352 321c-1.254 5.984-10.367 80.213-7.387 97.942s51.562 54.878 53.689 55.528c2.479-1.819 6.128-7.784 6.128-7.784s-35.622-41.294-36.3-42.95 7.8-97.283 7.8-97.283z",
    transform: "translate(-759.369 -212.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    fill: "#f081ec",
    d: "M843.077 341.736L806.731 489.98H794.49l12.4-154.65z",
    transform: "translate(-777.078 -219.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    d: "M802.017 177.05c5.017 0 31.19.848 35.92 10.059s.273 51.79-2.667 53.441c-1.587.887-2.018.025-2.479 1.829s-4.958 19.549-4.958 19.549c-2.856.079-44.492-6.192-58.007-13.525.079-2.038.734-7.338.734-7.744-1.795.734-3.966.887-4.561 0-5.275-7.987 2.588-49.628 8.23-58.007 2.399-3.594 19.737-5.577 27.788-5.602z",
    className: "cls-28",
    transform: "translate(-761.834 -140.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    fill: "#e2a203",
    d: "M875.18 306.522c1.229 0 11.815 7.437 10.907 11.091.744-2.935 3.084-12 3.084-12-1.006.187-13.089.924-13.991.909z",
    transform: "translate(-817.763 -204.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    d: "M834.329 167.02c.573 0-1.845 2.363-.439 3.948.856.964 8.728 1.767 10.734.685s3.886-2 3.786-5.236a122.564 122.564 0 0 0-1.341-12.986c-.354-1.235-.78-4.543-2.124-6.764a24.386 24.386 0 0 0-3.867-4.491c-1.578.001-6.749 24.844-6.749 24.844z",
    className: "cls-17",
    transform: "translate(-790.769 -134.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    d: "M840.527 170.211c0 .8-5.745 13.6-9.089 13.612-3.029.008-3.658-12.8-3.658-13.612V153.85h12.747z",
    className: "cls-34",
    transform: "translate(-793.863 -128.391)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    cx: 12.4,
    cy: 12.4,
    r: 12.4,
    className: "cls-34",
    transform: "translate(25.206 5.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    d: "M816.252 102.5c-6.366 0-10.332 4-10.332 9.118 0 4.259 1.031 6.668 2.246 7.278.768-4.135 2.439-6.049 3.823-6.872 1.076.823 2.915 2.816 5.374 3.431s10.268 1.465 15.439 5.223c1.691-1.537 1.968-4.5 1.968-6.859s-1.041-5.31-7.164-7.015c-4.046-1.126-4.611-4.304-11.354-4.304z",
    className: "cls-17",
    transform: "translate(-782.841 -102.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    cx: 2.866,
    cy: 2.866,
    r: 2.866,
    className: "cls-34",
    transform: "translate(46.202 16.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    d: "M825.313 226.26c-.223 2.737 1.556 15.146-.768 18.042s-42.245 19.509-48.835 21.492",
    className: "cls-35",
    transform: "translate(-767.609 -164.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    d: "M784.017 217.65c-.878 3.064-3.832 16.971-1.755 23.431",
    className: "cls-35",
    transform: "translate(-770.546 -160.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    d: "M806.15 293.24c1.983 1.393 20.992 9.807 47.273 6.634",
    className: "cls-35",
    transform: "translate(-781.965 -198.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    d: "M864.956 284.584c-1.4 8.028.372 10.585 7.061 10.4",
    className: "cls-36",
    transform: "translate(-808.694 -163.524)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    d: "M841.963 266.8c-.146.92.737 6.038-2.985 5.573",
    className: "cls-36",
    transform: "translate(-831.565 -157.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    d: "M792.107 262.718c1.274.2-2.88-3.114-5.236-1.879s-5.528 6.822-4.878 8.116a1.676 1.676 0 0 0 2.479.823c.639-.411 5.413-7.417 7.635-7.06z",
    className: "cls-34",
    transform: "translate(-770.733 -182.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    d: "M875.736 616.08c.679.5 6.7 4.571 6.753 7.139s-5.612 11.081-6.753 11.324-1.953-.719-1.953-2.439 2.152-4.735 1.864-6.073-3.069-3.788-4.5-3.832",
    className: "cls-17",
    transform: "translate(-815.731 -361.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    d: "M797.9 647.26c0 1.18.684 8.587-.684 9.276s-16.47 1.1-17.154.412-1.1-2.127-.5-2.538 6.445-1.582 7.238-2.127 1.889-3.47 1.487-5.022",
    className: "cls-17",
    transform: "translate(-769.404 -377.176)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chair",
    transform: "translate(501.58 527.978)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116-2",
    cx: 33.34,
    cy: 7.369,
    rx: 33.34,
    ry: 7.369,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_87-2",
    d: "M0 0L18.727 58.612",
    className: "cls-37",
    transform: "translate(46.009 6.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_88-2",
    d: "M18.727 0L0 58.612",
    className: "cls-37",
    transform: "translate(6.164 7.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94",
    d: "M5.9 0L0 58.43",
    className: "cls-37",
    transform: "translate(32.266 7.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_89",
    d: "M24.737 14.48L0 0",
    className: "cls-38",
    transform: "translate(35.283 35.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_95",
    d: "M16.291 20.514L0 0",
    className: "cls-38",
    transform: "translate(17.182 31.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_96",
    d: "M24.134 0L0 13.274",
    className: "cls-38",
    transform: "translate(11.15 35.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_90",
    d: "M21.524 0L0 14.348",
    className: "cls-38",
    transform: "translate(34.077 38.178)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(413.369 372.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    fill: "#78e580",
    d: "M256.375 320.591l-9.055-3.249c.391-16.519 4.253-53.43 9.736-58.919 1.289-1.284 26.784-3.524 31.332-3.524 27.143 0 35.194 3.1 37.238 5.145 6.339 6.339 8.315 35.712 8.315 46s-29.055 15.621-29.055 15.621L270.828 324s-7.47.771-13.931 1.152c-.142-1.977-.522-4.561-.522-4.561z",
    transform: "translate(-167.636 -209.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    d: "M499.965 395.456c-2.478-.734-27.116-4.755-32.484.528s-22.262 81.022-22.262 82.765h13.6l18.363-39.52",
    className: "cls-40",
    transform: "translate(-438.207 -274.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    fill: "#6cbdc4",
    d: "M390.256 384.148c.618 3.09 4.332 6.408 4.332 23.244 0 23.281-19.071 23.772-25.917 23.772-21.332 0-55.844-6.339-58.174-7.5-1.548 2.589-30.038 60.752-30.17 62.052H267.21s8.13-87.018 22.8-96.886c4.766-3.171 89.306-6.563 100.246-4.682z",
    transform: "translate(-238.791 -269.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    d: "M407.649 352.41c3.444 0 6.286.819 14.084 2.351l.407 14.919c-7.4-2.979-9.113-7.121-11.258-7.121-5.357 0-8.157 2.763-11.321 2.763-2.208 0-6.181-1.733-6.181-4.089 0-4.933 10-8.823 14.269-8.823z",
    className: "cls-13",
    transform: "translate(-332.994 -255.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    d: "M320.75 247.087c0 1.992 11.564 2.05 11.564 0v-16.2H320.75z",
    className: "cls-13",
    transform: "translate(-204.8 -197.952)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    cx: 13.999,
    cy: 13.999,
    r: 13.999,
    className: "cls-13",
    transform: "translate(103.483 10.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    d: "M312.066 182.518c1.733 2.752 5.357 4.015 9.282 4.015 3.344 0 8.215-.972 11.68 1 1.875 1.057 4.025 3.46 4.459 8.273 0 .824.935 4.02.935 5.05 0 .7.792 1.162 2.113 1.162a2.771 2.771 0 0 0 2.029-2.789c0-1.949-.777-2.641-.777-4.295s2.023-3.244 2.023-7.84c0-6.619-4.226-10.7-7.216-10.7-2.726 0-3.582.634-3.925.9 0-6.017-7.924-8.764-11.067-8.764-3.592 0-5.283 1.474-5.283 3.349 0 2.99 1.426 5.531 2.15 6.1a8.875 8.875 0 0 0-5.97-2.277c-4.115 0-5.5 2.7-5.5 4.554 0 4.02 4.823 7.745 6.619 7.745a19.192 19.192 0 0 1 1.585-2.742",
    className: "cls-42",
    transform: "translate(-209.033 -168.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    d: "M388.654 298.62c-1.057 2.245-6.154 23.9-6.154 30.767",
    className: "cls-43",
    transform: "translate(-293.762 -229.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    d: "M337.471 348.41c0 24.348-.227 31.411-10 31.411-22.526 0-56.579-18.49-62.648-18.49-5.362 0-8.162 2.768-11.326 2.768-2.2 0-6.176-1.738-6.176-4.089 0-4.939 10-8.827 14.264-8.827 9.6 0 47.9 9.255 48.839 9.255s2.509-.407 2.509-1.981c0-2.858-1.87-9.461-2.113-10.037z",
    className: "cls-13",
    transform: "translate(-171.166 -253.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    d: "M296.59 308.21c.645 1.854 5.668 21.015 6.249 23.35",
    className: "cls-43",
    transform: "translate(-162.563 -234.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    d: "M544.056 553.07c0 1.257.734 9.15-.729 9.884s-17.549 1.167-18.279.438-1.167-2.266-.528-2.7 6.868-1.685 7.713-2.272 2.013-3.7 1.585-5.346",
    className: "cls-40",
    transform: "translate(-524.211 -349.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    d: "M504.686 574.68c0 1.252.734 9.15-.729 9.879s-17.549 1.173-18.278.439-1.168-2.266-.528-2.7 6.868-1.68 7.713-2.266 2.013-3.7 1.585-5.346",
    className: "cls-17",
    transform: "translate(-464.042 -360.125)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(331.545 483.144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    width: 5.41,
    height: 111.783,
    fill: "#3b3737",
    rx: 2.705,
    transform: "matrix(-0.967, 0.254, -0.254, -0.967, 70.011, 112.501)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    width: 5.419,
    height: 111.973,
    className: "cls-45",
    rx: 2.709,
    transform: "translate(27.946 2.201) rotate(14.452)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    width: 5.41,
    height: 111.783,
    fill: "#343434",
    rx: 2.705,
    transform: "matrix(-0.967, 0.254, -0.254, -0.967, 318.344, 112.504)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    width: 281.768,
    height: 8.003,
    className: "cls-45",
    rx: 4.002,
    transform: "translate(18 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    width: 5.409,
    height: 111.783,
    className: "cls-45",
    rx: 2.705,
    transform: "matrix(0.967, 0.254, -0.254, 0.967, 276.43, 4.397)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(427.047 450.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    fill: "#a8a8a8",
    d: "M436.2 348.69h48.87l-8.854-30.45a3.555 3.555 0 0 0-3.423-2.53h-41.47a3.5 3.5 0 0 0-3.423 4.443z",
    transform: "translate(-427.77 -315.709)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    cx: 2.99,
    cy: 2.99,
    r: 2.99,
    fill: "#6c6c6c",
    transform: "translate(23.876 13.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_466",
    fill: "#e5e5e5",
    d: "M0 0H34.291V2.14H0z",
    transform: "translate(51.494 30.841)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pot",
    transform: "translate(479.259 536.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    d: "M58.119 429.938c-10.037 1.9-8.246 61.808 11.02 58.185 18.194-3.455 1.226-60.515-11.02-58.185z",
    transform: "translate(-39.024 -406.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    d: "M30.086 443.7c-7.988-4.522-41.422 37.55-26.129 46.2 14.449 8.21 35.855-40.688 26.129-46.2z",
    className: "cls-28",
    transform: "translate(33.079 -412.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    d: "M68.08 385.73c-7.644 2.219-1.786 48.459 12.853 44.2 13.819-4.014-3.55-46.904-12.853-44.2z",
    className: "cls-30",
    transform: "translate(-54.652 -385.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    d: "M69.977 454.837c-5.283 4.554 16.208 39.388 26.361 30.64 9.588-8.225-19.911-36.177-26.361-30.64z",
    className: "cls-28",
    transform: "translate(-69.154 -417.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    fill: "#8cf894",
    d: "M50.693 394.94c-11.442 0-21.918 73.061 0 73.061 20.698-.001 13.931-73.061 0-73.061z",
    transform: "translate(-18.2 -390.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    width: 44.534,
    height: 8.178,
    fill: "#d8d8d8",
    rx: 4.05,
    transform: "translate(10.274 76.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    d: "M0 2.665c0 5.27 47.2 33.647 47 24.87S0-8.56 0 2.665z",
    className: "cls-2",
    transform: "matrix(0.809, -0.588, 0.588, 0.809, 14.45, 112.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    fill: "#969696",
    d: "M38.176 568.579h20.17a3.3 3.3 0 0 0 3.281-2.937l2.546-22.864a3.307 3.307 0 0 0-3.281-3.7H35.736a3.3 3.3 0 0 0-3.281 3.656L34.89 565.6a3.307 3.307 0 0 0 3.286 2.979z",
    transform: "translate(-15.715 -458.004)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-3",
    transform: "translate(154.311 303.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    d: "M189.216 443.89c-.058.95-.642 6.51.1 7.492 1.355 1.778 13.187 1.688 13.771 1.175s.982-1.656.507-2.016-5.1-1.592-5.707-2.067a5.312 5.312 0 0 1-.944-4.109",
    className: "cls-17",
    transform: "translate(-181.307 -158.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    fill: "#e85a0f",
    d: "M126.489 204.66c2.016 4.571 18.945 54.37 18.554 61.631s-39.566 82.079-41.73 82.868-11.151-1.971-11.877-3.935 13.649-46.615 14.04-58.049",
    transform: "translate(-59.94 -73.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    fill: "#f26d27",
    d: "M180.692 200.568c-1.014 5.386-17.86 79.665-17.86 79.665l-30.886 74.8c-2.568 1.252-10.124 1.387-11.447.989s5.027-72.025 7.537-82.175 9.116-80.615 9.116-80.615 34.604.568 43.54 7.336z",
    transform: "translate(-114.143 -69.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    d: "M11.323 80.87c5.1 2.382 37.6 18.374 40.394 18.374s32.5-16.788 34.25-17.918c1.663 1.663 4.2 4.282 3.582 5.136s-34.687 32.69-37.576 32.69-32.151-8.9-34.424-11.35",
    className: "cls-55",
    transform: "translate(46.88 -28.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    d: "M141.839 75.351c29.211-4.789 22.251 79.742 19.375 82.945s-42.275-4.494-44.837-7.524 4.963-74.619 25.462-75.421z",
    className: "cls-55",
    transform: "translate(-94.665 -26.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    d: "M156.186 424.44c-.347.88-2.606 6-2.189 7.158.751 2.106 12.037 5.624 12.75 5.309s1.444-1.284 1.1-1.765-4.378-3.062-4.815-3.7a5.251 5.251 0 0 1 .36-4.2",
    className: "cls-17",
    transform: "translate(-122.976 -151.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    d: "M151.478 74.8c0 2.016-8.988 2.17-8.988 0V61.32h8.988z",
    className: "cls-13",
    transform: "translate(-99.162 -21.953)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173",
    cx: 11.678,
    cy: 11.678,
    r: 11.678,
    className: "cls-13",
    transform: "translate(37.595 17.321)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    cx: 2.574,
    cy: 2.574,
    r: 2.574,
    className: "cls-13",
    transform: "translate(39.572 26.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    d: "M155.572 133.493c-12.949-.353-22.251-9.418-22.251-32.742 0-9.63 16.011-38.622 19.189-49.575 1.644-5.656.321-22.3 8.712-30.764 4.045-4.077 21.828-3.114 26.418-1.194s4.051 7.7 3.582 8.609c-1.1-.924-3.505-2.8-3.935-2.741-2.253.276-8.4 7.2-10.272 10.375-1.515 2.568.822 18.515-2.138 23.073S161.44 60.7 161.44 60.7",
    className: "cls-17",
    transform: "translate(-133.321 -6.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    d: "M181.809 111.612c-1.791 2.241-15.016 26.1-15.016 29.692s3.923 29.024 4.706 30.257c-1.791 1.342-6.5 5.04-6.5 5.04s-14.342-25.327-14.342-39.553c0-5.046 11.427-46.056 22.412-55.468",
    className: "cls-55",
    transform: "translate(-134.739 -29.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    d: "M165.676 128.36c-1.791 2.241-15.016 26.1-15.016 29.692 0 1.778.969 8.93 2.035 15.838",
    className: "cls-56",
    transform: "translate(-118.605 -45.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    d: "M179.16 73.986c.546 4.738-13.276 21.269-18.663 26.11-5.38-6.779-2.151-23.574-2.151-23.574l10.978-5.072z",
    className: "cls-17",
    transform: "translate(-136.423 -25.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_177",
    cx: 5.669,
    cy: 6.69,
    className: "cls-17",
    rx: 5.669,
    ry: 6.69,
    transform: "translate(24.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    d: "M117.54 92.33c2.658 5.836 4.3 13.482 5.239 21.584",
    className: "cls-56",
    transform: "translate(-54.445 -33.055)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_178",
    cx: 5.463,
    cy: 4.507,
    className: "cls-13",
    rx: 5.463,
    ry: 4.507,
    transform: "translate(132.867 48.246)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    d: "M2.227 0C-.051-.065.4 1.164.065 2.9a6.992 6.992 0 0 0 .826 4.033c.6.193 1.6-2.464 1.9-2.759.517-.5 1.125.8 1.89.72C4.851 4.016 4.5.07 2.227 0z",
    className: "cls-42",
    transform: "translate(523.59 412.944) rotate(-152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    d: "M7.288 4.264C-.938 4.3 1.341 1.459.135.46S6.2 2.617 7.3 2.787c1.866.29 5.454-2.834 8.218-2.787.613.507-.005 4.225-8.23 4.264z",
    className: "cls-42",
    transform: "matrix(-1, 0.017, -0.017, -1, 532.496, 405.097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    transform: "translate(343.544 400.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    d: "M268.863 313.858l6.631-5.858h-6.764z",
    className: "cls-30",
    transform: "translate(-260.204 -285.803)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    width: 51.284,
    height: 22.547,
    className: "cls-30",
    rx: 11.274,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    cx: 1.989,
    cy: 1.989,
    r: 1.989,
    className: "cls-4",
    transform: "translate(16.8 9.284)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    cx: 1.989,
    cy: 1.989,
    r: 1.989,
    className: "cls-4",
    transform: "translate(23.652 9.284)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    cx: 1.989,
    cy: 1.989,
    r: 1.989,
    className: "cls-4",
    transform: "translate(30.505 9.284)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2003",
    transform: "translate(624.799 272.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    d: "M735.74 163.927L729.03 158h6.845z",
    className: "cls-25",
    transform: "translate(-690.557 -135.856)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    width: 51.893,
    height: 22.815,
    className: "cls-25",
    rx: 11.408,
    transform: "translate(51.893 22.815) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    cx: 2.013,
    cy: 2.013,
    r: 2.013,
    className: "cls-4",
    transform: "translate(30.867 9.394)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    cx: 2.013,
    cy: 2.013,
    r: 2.013,
    className: "cls-4",
    transform: "translate(23.933 9.394)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    cx: 2.013,
    cy: 2.013,
    r: 2.013,
    className: "cls-4",
    transform: "translate(16.999 9.394)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "plant2",
    transform: "translate(102.345 483.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    fill: "#b5bdd1",
    d: "M637.571 585.366v-.632l-1.516-1.895-3.505-4.257-3.727-4.51s-3.588-2.482-4.51-2.912a24.582 24.582 0 0 0-10.624-2.741c-2.432 0-11.521.366-11.54 1.895 0 2.268 12.727 10.851 22.062 15.02 4.1.032 13.36.032 13.36.032z",
    transform: "translate(-601.933 -500.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    fill: "#c6b486",
    d: "M635.518 545.979c-12.955-9.967-39.4-64.33-32.617-84.479 14.439 7.358 30.28 32.73 37.752 54.155a38.4 38.4 0 0 1 .966 4.238l3.032 13.9.733 12.207z",
    transform: "translate(-601.807 -461.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    fill: "#73e5a3",
    d: "M665.793 548.182c-4.371-3.55-5.767-14.06-5.8-17.982-.069-7.32 1.055-12.714 7.314-20.768s4.592-21.412 12.9-30.425 13.82-11.527 23.686-11.527 13 15.993 12.948 20.016c-.114 16.233-10.34 18.532-16.58 26.275-4.529 5.621-4.882 10.219-6.253 12.847-7.352 14.161-13.327 19.485-17.748 21.563",
    transform: "translate(-623.239 -463.703)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    d: "M673 549.357c.126-27.684 29.3-69.263 35.535-75.5",
    className: "cls-60",
    transform: "translate(-628.033 -466.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    d: "M672.126 564.091c-3.228-3.518-6.165-13.491-5.722-16.081",
    className: "cls-60",
    transform: "translate(-625.587 -493.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    d: "M642.36 546.722C637.787 538.619 616.091 499.1 608 470",
    className: "cls-60",
    transform: "translate(-604.088 -464.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    fill: "#b37361",
    d: "M662.832 595.25h13.592l-11.369 42.318h-30.4L623.47 595.25h39.362",
    transform: "translate(-609.788 -510.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    d: "M609.19 572.78c6.626.455 14.963.758 20.843 4.769",
    className: "cls-60",
    transform: "translate(-604.527 -502.494)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    transform: "translate(375.341 114.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    width: 113.477,
    height: 41.636,
    className: "cls-4",
    rx: 10,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_49",
    fill: "#ededed",
    d: "M10 0h93.477a10 10 0 0 1 10 10v13.675H0V10A10 10 0 0 1 10 0z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Send_invoice_to_Ford_Perfect_",
    fill: "#7b8295",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: "5px",
    fontWeight: 700,
    transform: "translate(11.43 11.531)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Send invoice to"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    className: "cls-64"
  }, "Ford Perfect ?"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    transform: "translate(0 20.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_49-2",
    d: "M0 0h113.477v11.226a10 10 0 0 1-10 10H10a10 10 0 0 1-10-10V0z",
    className: "cls-4",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    transform: "translate(62.507 24.669)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Cancel",
    fill: "#c13030",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: "4px",
    fontWeight: 700,
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cancel")), /*#__PURE__*/React.createElement("g", {
    id: "criss-cross",
    transform: "translate(22.597 0.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    fill: "#f78e8e",
    d: "M4.487 0a4.487 4.487 0 1 0 4.487 4.487A4.492 4.492 0 0 0 4.487 0zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    fill: "#fafafa",
    d: "M158.886 158.357a.374.374 0 1 1-.529.529l-1.124-1.124-1.124 1.124a.374.374 0 1 1-.529-.529l1.124-1.124-1.124-1.124a.374.374 0 0 1 .529-.529l1.124 1.124 1.124-1.124a.374.374 0 1 1 .529.529l-1.124 1.124zm0 0",
    transform: "translate(-152.747 -152.747)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    transform: "translate(17.606 24.669)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Send",
    fill: "#18ac29",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: "5px",
    fontWeight: 700,
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Send")), /*#__PURE__*/React.createElement("g", {
    id: "criss-cross-2",
    transform: "translate(19.346 0.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    fill: "#67dd75",
    d: "M4.487 0a4.487 4.487 0 1 0 4.487 4.487A4.492 4.492 0 0 0 4.487 0zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M3850.8 3573.719l1.445 1.658 2.765-2.692",
    transform: "translate(-3848.435 -3569.549)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    transform: "translate(479.259 199.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232-2",
    width: 200.831,
    height: 31.839,
    className: "cls-4",
    rx: 10,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    transform: "translate(16.25 9.662)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Received_from_Arthur_Dunt",
    fill: "#7b8295",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: "7px",
    fontWeight: 700,
    transform: "translate(48.244 7.135)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Received from"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    className: "cls-64"
  }, "Arthur Dunt")), /*#__PURE__*/React.createElement("text", {
    id: "_1200-2",
    fill: "#51cc64",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: "7px",
    fontWeight: 700,
    transform: "translate(13.956 7.135)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$1200")), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    fill: "#51cc64",
    d: "M3.91 10.012V3.576l-1.7 1.48a1.422 1.422 0 0 1-1.971.126 1.425 1.425 0 0 1 .4-1.936L3.8.5a1.993 1.993 0 0 1 .505-.327A1.505 1.505 0 0 1 6.08.5l3.162 2.745c.654.57.865 1.4.469 1.857s-1.247.363-1.9-.206L6.245 3.535v6.476a1.168 1.168 0 1 1-2.336 0z",
    transform: "translate(0 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupBg);
export default __webpack_public_path__ + "static/media/signup_bg.aaab7eeb65f86da281bf67908de66129.svg";
export { ForwardRef as ReactComponent };